import { useMemo } from "react";

import { cn } from "~/core/generic/shadcn-utils";

import { getColorPresetClasses } from "~/components/ColorPresetsPicker/utils";
import OctoTag from "~/components/OctoTag";

import { DDRendererItem } from "../../types";

export default function StageLabel({ stage }: { stage: DDRendererItem }) {
  const colors = useMemo(
    () => getColorPresetClasses(stage?.metadata?.color),
    [stage],
  );

  return (
    <OctoTag className={cn(colors.bgClass, colors.textClass, "w-fit")}>
      {stage?.label}
    </OctoTag>
  );
}
